import { render } from "./carousel.vue?vue&type=template&id=f4022360&ts=true"
import script from "./carousel.vue?vue&type=script&lang=ts"
export * from "./carousel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__